import { oneOf, str, nullableStr, bool } from '../../lib/viewState';
import type { ProjectPhase } from '../../../shared/types';
import { ACTIVE_PHASES } from './constants';
import { parseSort, serializeSort } from './helpers';
import type { View } from './types';

export const projectsViewCodec = {
  view: oneOf('view', ['active', 'delivered', 'all', 'clean_up'], 'active'), query: str('q'),
  client: nullableStr('client'),
  video_type: nullableStr('type'),
  archive: nullableStr('archive'),
  // null means this tab's default; pages resolve it with defaultSortFor(view).
  sort: { ...nullableStr('sort'), dec: (raw: string) => {
    const parsed = parseSort(raw);
    return parsed && serializeSort(parsed) === raw ? raw : undefined;
  } },
  showVoided: bool('voided'), showNumberedTrash: bool('trash'),
  phase: { ...nullableStr('phase'), dec: (raw: string, params?: URLSearchParams) => {
    if (['delivered', 'all', 'clean_up'].includes(params?.get('view') ?? '')) return null;
    return ACTIVE_PHASES.includes(raw as ProjectPhase) ? raw : undefined;
  } },
};

/** Tab changes clear phase and return to that tab's default sort. */
export function projectViewChange(view: View) {
  return { view, phase: null, sort: null };
}
